import TalkCallToAction from "../talk-cta/TalkCallToAction";
import defaultImage from "../../assets/images/solutions/quick.png";
import MassagemIcon from "../../assets/images/icons/massagem.svg";
import YogaIcon from "../../assets/images/icons/yoga.svg";
import HomeIcon from "../../assets/images/icons/home.svg";
import WorkshopIcon from "../../assets/images/icons/workshop.svg";
import RelatorioIcon from "../../assets/images/icons/relatorio.svg";
import QuickIcon from "../../assets/images/icons/quick.svg";
import massagemImage from "../../assets/images/solutions/massagem.png";
import groupImage from "../../assets/images/solutions/group.png";
import workshopImage from "../../assets/images/solutions/workshop.png";
import quickImage from "../../assets/images/solutions/quick.png";
import homeImage from "../../assets/images/solutions/home.png";
import relatorioImage from "../../assets/images/solutions/relatorio.png";
import SolutionsCarousel from "./SolutionsCarousel";
import "./SolutionPage.scss";

type SolutionPageTemplateProps = {
  title: string;
  intro: string[];
  benefits: string[];
  image?: string;
  imageAlt?: string;
  modifier?: string;
  sectionId?: string;
};

const solutionImages: Record<string, string> = {
  "massagens-terapias-individuais": massagemImage,
  "yoga-laboral-atividades-grupo": groupImage,
  "workshops-palestras-corporativas": workshopImage,
  "quick-massage-eventos-corporativos": quickImage,
  "atendimento-online-home-office": homeImage,
  "relatorios-gestao-programa": relatorioImage,
};

const solutionCards = [
  {
    title: "Massagens e Terapias Individuais",
    image: massagemImage,
    icon: <img src={MassagemIcon} alt="Massagem" className="main-solutions__icon" />,
    route: "/solutions/massagens-terapias-individuais",
    sectionId: "massagens-terapias-individuais",
  },
  {
    title: "Atividades em Grupo e Rotinas de Descompressão",
    image: groupImage,
    icon: <img src={YogaIcon} alt="Yoga" className="main-solutions__icon" />,
    route: "/solutions/yoga-laboral-atividades-grupo",
    sectionId: "yoga-laboral-atividades-grupo",
  },
  {
    title: "Workshops e Palestras",
    image: workshopImage,
    icon: <img src={WorkshopIcon} alt="Workshop" className="main-solutions__icon" />,
    route: "/solutions/workshops-palestras-corporativas",
    sectionId: "workshops-palestras-corporativas",
  },
  {
    title: "Quick Massage e Eventos Corporativos",
    image: quickImage,
    icon: <img src={QuickIcon} alt="Quick Massage" className="main-solutions__icon" />,
    route: "/solutions/quick-massage-eventos-corporativos",
    sectionId: "quick-massage-eventos-corporativos",
  },
  {
    title: "Bem-Estar no Home Office",
    image: homeImage,
    icon: <img src={HomeIcon} alt="Home Office" className="main-solutions__icon" />,
    route: "/solutions/atendimento-online-home-office",
    sectionId: "atendimento-online-home-office",
  },
  {
    title: "Gestão do Programa",
    image: relatorioImage,
    icon: <img src={RelatorioIcon} alt="Relatório" className="main-solutions__icon" />,
    route: "/solutions/relatorios-gestao-programa",
    sectionId: "relatorios-gestao-programa",
  },
];

const SolutionPageTemplate = ({
  title,
  intro,
  benefits,
  image,
  imageAlt = "Imagem ilustrativa de bem-estar corporativo",
  modifier = "",
  sectionId = "",
}: SolutionPageTemplateProps) => (
  <>
    <section id={sectionId}>
      <div className={`solution-page ${modifier}`}>
        <div className="solution-page__inner" data-aos="fade-up">
          <div className="solution-page__image" data-aos="fade-up">
            <img src={image || solutionImages[sectionId] || defaultImage} alt={imageAlt} />
          </div>

          <div className="solution-page__body">
            <div className="page-header">
              <h1>{title}</h1>
              {intro.map((paragraph, index) => (
                <p key={index}>{paragraph}</p>
              ))}

              <div className="solution-page__benefits">
                <h2>Principais Benefícios</h2>
                <ul className="benefits-list">
                  {benefits.map((benefit, index) => (
                    <li key={index}>{benefit}</li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="solution-page__carousel-wrap" data-aos="fade-up" data-aos-delay="100">
        <h2>Outras Soluções</h2>
        <SolutionsCarousel solutions={solutionCards} currentSectionId={sectionId} />
      </div>
    </section>
    <TalkCallToAction />
  </>
);

export default SolutionPageTemplate;
